<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="类型" prop="type">
          <!-- <div class="flex"> -->
          <a-select v-model="form.type" @change="handleChange">
            <a-select-option
              :value="item.text"
              v-for="item in lxlist"
              :key="item.text"
              >{{ item.title }}</a-select-option
            >
          </a-select>
          <!-- <template v-if="form.levelType == '其他'">
              <a-input v-model="form.otherType" class="ipt-other" />
            </template> -->
          <!-- </div> -->
        </a-form-model-item>
        <a-form-model-item
          :label="
            form && form.type && form.type.indexOf('项目完成') != '-1'
              ? '项目名称'
              : '文章名称'
          "
          prop="xmmc"
        >
          <a-input v-model="form.xmmc" @blur="changeUpdate" />
        </a-form-model-item>
        <a-form-model-item
          :label="
            form && form.type && form.type.indexOf('项目完成') != '-1'
              ? '立项单位'
              : '发表期刊'
          "
          prop="lxdw"
        >
          <a-input v-model="form.lxdw" @blur="changeUpdate" />
        </a-form-model-item>
        <a-form-model-item
          :label="
            form && form.type && form.type.indexOf('项目完成') != '-1'
              ? '立项时间'
              : '发表时间'
          "
          prop="lxsj"
        >
          <a-date-picker
            v-model="form.lxsj"
            @change="changedate"
            :locale="locale"
          />
        </a-form-model-item>
        <a-form-model-item
          v-if="form && form.type && form.type.indexOf('项目完成') != '-1'"
          prop="jxsj"
          :label="
            form && form.type.indexOf('项目完成') != '-1' ? '结项时间' : ''
          "
        >
          <a-date-picker
            v-model="form.jxsj"
            @change="changedate1"
            :locale="locale"
          />
        </a-form-model-item>
        <a-form-model-item
          label="项目级别"
          v-if="form && form.type && form.type.indexOf('项目完成') != '-1'"
          prop="xnjb"
        >
          <div class="flex">
            <a-select v-model="form.xnjb" @change="changeUpdate">
              <a-select-option
                :value="item.text"
                v-for="item in jblist"
                :key="item.text"
                >{{ item.title }}</a-select-option
              >
            </a-select>
            <!-- <template v-if="form.levelType == '其他'">
              <a-input v-model="form.otherType" class="ipt-other" />
            </template> -->
          </div>
        </a-form-model-item>
        <a-form-model-item
          label="资助金额"
          v-if="form && form.type && form.type.indexOf('项目完成') != '-1'"
          prop="zzje"
        >
          <div class="flex">
            <a-input-number :min="0" @blur="changeUpdate" v-model="form.zzje" />
            <span class="surplus-money"> 万元 </span>
          </div>
        </a-form-model-item>
        <!-- <a-form-model-item label="年份" prop="year">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.year"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearyear"
          />
        </a-form-model-item> -->
        <!-- <a-form-model-item label="成果名称" prop="title">
          <a-input v-model="form.title" />
        </a-form-model-item> -->

        <!-- <a-form-model-item label="数量" prop="num">
          <a-input-number
            v-model="form.num"
            min="1"
            precision="0"
            @blur="blurValue"
          />
        </a-form-model-item> -->
        <!-- -->
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
import { emptyToNull } from "@/utils/time";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        // title: "",
        year: "",
        // achievementType: "",
        num: "",
        type: "",
        xmmc: "",
        num: "",
        lxdw: "",
        lxsj: "",
        jxsj: "",
        xnjb: "",
        // levelType: "",
        // content: "",
        // courseType: "",
        // otherType: "",
      },
      rules: {},
      rules1: {
        type: [
          {
            validator: (rule, value, callback) => {
              if (this.form.type != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择类型"));
              }
            },
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        xmmc: [
          {
            validator: (rule, value, callback) => {
              if (this.form.xmmc != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入项目名称"));
              }
            },
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        lxdw: [
          {
            validator: (rule, value, callback) => {
              if (this.form.lxdw != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入立项单位"));
              }
            },
            required: true,
            message: "请输入立项单位",
            trigger: "blur",
          },
        ],
        lxsj: [
          {
            validator: (rule, value, callback) => {
              if (this.form.lxsj != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入立项时间"));
              }
            },
            required: true,
            message: "请输入立项时间",
            trigger: "change",
          },
        ],
        jxsj: [
          {
            validator: (rule, value, callback) => {
              if (this.form.jxsj != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入结项时间"));
              }
            },
            required: true,
            message: "请输入结项时间",
            trigger: "change",
          },
        ],
        xnjb: [
          {
            validator: (rule, value, callback) => {
              if (this.form.xnjb != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择级别"));
              }
            },
            required: true,
            message: "请选择级别",
            trigger: "change",
          },
        ],
        zzje: [
          {
            validator: (rule, value, callback) => {
              console.log(this.form.zzje, "zzje");
              console.log(this.form.zzje != "", 8888);
              if (this.form.zzje != "" || this.form.zzje == 0) {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入资助金额"));
              }
            },
            required: true,
            message: "请输入资助金额",
            trigger: "blur",
          },
        ],
      },
      rules2: {
        type: [
          {
            validator: (rule, value, callback) => {
              if (this.form.type != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择类型"));
              }
            },
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        xmmc: [
          {
            validator: (rule, value, callback) => {
              if (this.form.xmmc != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入文章名称"));
              }
            },
            required: true,
            message: "请输入文章名称",
            trigger: "blur",
          },
        ],
        lxdw: [
          {
            validator: (rule, value, callback) => {
              if (this.form.lxdw != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入发表期刊"));
              }
            },
            required: true,
            message: "请输入发表期刊",
            trigger: "blur",
          },
        ],
        lxsj: [
          {
            validator: (rule, value, callback) => {
              if (this.form.lxsj != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入发表时间"));
              }
            },
            required: true,
            message: "请输入发表时间",
            trigger: "change",
          },
        ],
        // xnjb: [
        //   {
        //     required: true,
        //     message: "请输入级别",
        //     trigger: "change",
        //   },
        // ],
        // num: [
        //   {
        //     required: true,
        //     message: "请输入资助金额",
        //     trigger: "blur",
        //   },
        // ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      lxlist: [],
      ishow: false,
      ifirst: true,
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
  },
  methods: {
    changedate(value) {
      const date = moment(value).format("YYYY-MM-DD");
      // console.log(year,"5555");
      this.form.lxsj = date + "";
      this.$forceUpdate();
    },
    changedate1(value) {
      const date = moment(value).format("YYYY-MM-DD");
      // console.log(year,"5555");
      this.form.jxsj = date + "";
      this.$forceUpdate();
    },
    blurValue() {
      if (this.form.num == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
        this.$forceUpdate();
      }
    },
    handleClearyear(val) {
      this.form.year = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    handleChange() {
      console.log(this.form.achievementType);
      // if (this.form.type.indexOf("项目完成") != "-1") {
      //   this.form.xmmc = "";
      //   this.form.lxdw = "";
      //   this.form.lxsj = "";
      //   this.form.jxsj = "";
      //   this.form.xnjb = "";
      //   this.form.num = "";
      // } else {
      //   this.form.xmmc = "";
      //   this.form.lxdw = "";
      //   this.form.lxsj = "";
      //   this.form.jxsj = "";
      //   this.form.xnjb = "";
      //   this.form.num = "";
      // }
      this.$forceUpdate();
      if (this.form.type.indexOf("项目完成") != "-1") {
        this.rules = this.rules1;
      } else {
        this.rules = this.rules2;
      }
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(); // 确保校验状态清除
      }
      // if (this.form.achievementType == "SZKC") {
      //   this.ishow = true;
      // } else {
      //   this.ishow = false;
      //   this.form.courseType = "";
      // }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    changeUpdate() {
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      const year = moment(value).format("YYYY");
      this.form.year = year + "";
      this.yearShowOne = false;
      // this.form.year = value;
      this.$refs.ruleForm.clearValidate("year");
      // this.yearShowOne = false;
    },
    getlxlist() {
      let schooltype = this.$store.state.user.schoolType;
      getAction(
        "/baseCommon/getDictItemsByCode?code=" +
          schooltype +
          "_researchsituation"
      ).then((res) => {
        if (res.code == 200) {
          this.lxlist = res.result;
        }
      });
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      // this.getxwlist();
      this.getcgjb();
      // this.getkclist();
      this.getlxlist();
      if (type == "add") {
        //this.form = {};
        this.form.num = "";
        this.form.type = "";
        this.form.xmmc = "";
        this.form.num = "";
        this.form.lxdw = "";
        this.form.lxsj = "";
        this.form.jxsj = "";
        this.form.xnjb = "";
        // this.form.applyId = record.id;
        this.form.year = new Date().getFullYear() + "";
        this.title = "新增科研情况";
        this.rules = this.rules2;
      } else {
        this.title = "编辑科研情况";
        const toFullDate = (val) => {
          if (val === null || val === undefined || val === "" || val === "null") {
            return "";
          }
          if (typeof val === "object" && val) {
            const m = moment(val);
            return m.isValid() ? m.format("YYYY-MM-DD") : "";
          }
          const s = String(val).trim();
          const bad = s.match(/^(20\d{2}|19\d{2})-(\d{1,2})-(\d{1,2})$/);
          if (bad) {
            const month = Number(bad[2]);
            const day = Number(bad[3]);
            if (month < 1 || month > 12 || day < 1 || day > 31) {
              return `${bad[1]}-01-01`;
            }
            return `${bad[1]}-${String(month).padStart(2, "0")}-${String(
              day
            ).padStart(2, "0")}`;
          }
          if (/^\d{4}$/.test(s)) return `${s}-01-01`;
          const yearRange = s.match(
            /^(20\d{2}|19\d{2})\s*[-~至到]\s*(20\d{2}|19\d{2})/
          );
          if (yearRange) return `${yearRange[1]}-01-01`;
          const m = moment(s);
          return m.isValid() ? m.format("YYYY-MM-DD") : "";
        };
        this.form = {
          title: record?.title,
          // achievementType: record.achievementType,
          // num: record.num,
          //   levelType: record.levelType,
          //   courseType: record.courseType,
          applyId: record.applyId,
          // year: record.year,
          id: record.id,
          type: record.type,
          num: record.num,
          xmmc: record.xmmc,
          lxdw: record.lxdw,
          lxsj: toFullDate(record.lxsj),
          jxsj: toFullDate(record.jxsj),
          xnjb: record.xnjb,
          zzje: Number(record.zzje) || 0,
          //   content: record.content,
          //   otherType:record.otherType,
        };
        if (record.type.indexOf("项目完成") != "-1") {
          this.rules = this.rules1;
        } else {
          this.rules = this.rules2;
        }
        // if (record.num == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }

        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=kyqkxmjb").then((res) => {
        if (res.code == 200) {
          this.jblist = res.result;
        }
      });
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      //  	this.$refs.ruleForm.clearValidate();
      // console.log(typeof this.form.year);
      if (
        typeof this.form.year == "object" &&
        this.form.year != "" &&
        this.type == "add"
      ) {
        this.form.year = new Date(this.form.year).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          const normalizeScienceParams = (form) => {
            const params = { ...form };
            Object.keys(params).forEach((key) => {
              params[key] = emptyToNull(params[key]);
            });
            // 发表篇数：结项时间/项目级别/资助金额不适用，空串会导致后端日期解析失败
            if (!params.type || String(params.type).indexOf("项目完成") === -1) {
              params.jxsj = null;
              params.xnjb = null;
              params.zzje = null;
            }
            const toFullDate = (val) => {
              if (val === null || val === undefined || val === "" || val === "null") {
                return null;
              }
              if (typeof val === "object" && val) {
                const m = moment(val);
                return m.isValid() ? m.format("YYYY-MM-DD") : null;
              }
              const s = String(val).trim();
              // 非法月日如 2018-20-01：取起始年
              const bad = s.match(/^(20\d{2}|19\d{2})-(\d{1,2})-(\d{1,2})$/);
              if (bad) {
                const month = Number(bad[2]);
                const day = Number(bad[3]);
                if (month < 1 || month > 12 || day < 1 || day > 31) {
                  return `${bad[1]}-01-01`;
                }
                return `${bad[1]}-${String(month).padStart(2, "0")}-${String(
                  day
                ).padStart(2, "0")}`;
              }
              if (/^\d{4}$/.test(s)) return `${s}-01-01`;
              const yearRange = s.match(
                /^(20\d{2}|19\d{2})\s*[-~至到]\s*(20\d{2}|19\d{2})/
              );
              if (yearRange) return `${yearRange[1]}-01-01`;
              const m = moment(s);
              return m.isValid() ? m.format("YYYY-MM-DD") : null;
            };
            params.lxsj = toFullDate(params.lxsj);
            if (params.type && String(params.type).indexOf("项目完成") !== -1) {
              params.jxsj = toFullDate(params.jxsj);
            }
            return params;
          };
          if (this.type == "add") {
            let params = normalizeScienceParams(this.form);
            //          params.year=new Date(this.form.year).getFullYear()+"";
            // params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("添加成功");
            this.$emit("addGain", { record: params, type: "add" });
            // postAction("/lxbase/lxResearchSituation/add", params).then((res) => {
            //   if (res.code == 200) {
            //     this.visible = false;
            //     this.$message.success("添加成功");
            //     this.$emit("addGain");
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
          } else {
            let params = normalizeScienceParams(this.form);
            //params.applyId = "1829722136428707841";
            if (typeof this.form.year == "object") {
              params.year = new Date(this.form.year).getFullYear() + "";
            }
            params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("编辑成功");
            this.$emit("addGain", { record: params, type: "edit" });
            // putAction("/lxbase/lxResearchSituation/edit", params).then((res) => {
            //   if (res.code == 200) {
            //     this.visible = false;
            //     this.$message.success("编辑成功");
            //     this.$emit("addGain");
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
.surplus-money {
  width: 200px;
  display: inline-block;
  margin-left: 12px;
}
</style>
  